import React, { FC } from 'react'
import { styled } from '@creditas/stylitas'
import ContentLoader from 'react-content-loader'

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`

const LoanInfoLoading: FC = () => (
  <Container>
    <ContentLoader height={138}>
      <rect x="12" y="4" rx="16" ry="16" width="120" height="32" />
      <rect x="144" y="4" rx="16" ry="16" width="100" height="32" />

      <rect x="6" y="61" rx="8" ry="8" width="200" height="14" />
      <rect x="6" y="90" rx="8" ry="8" width="150" height="14" />
      <rect x="6" y="112" rx="8" ry="8" width="170" height="14" />

      <rect x="348" y="61" rx="8" ry="8" width="240" height="14" />
      <rect x="348" y="90" rx="8" ry="8" width="240" height="14" />
      <rect x="348" y="112" rx="8" ry="8" width="210" height="14" />

      <rect x="807" y="7" rx="8" ry="8" width="60" height="14" />
      <rect x="785" y="27" rx="8" ry="8" width="82" height="14" />
      <rect x="819" y="93" rx="24" ry="24" width="48" height="48" />
    </ContentLoader>
  </Container>
)

export { LoanInfoLoading }
